import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C, LL_V_L, TS_CollapsableContainerV2 } from '@nu-art/thunderstorm-frontend';
import './Component_HomeHistory.scss';
import { AdvisorConfigKeyFE_HomePanel, ModuleFE_Advisor_Variable, ModuleFE_AdvisorState, ModuleFE_RuntimeFinding } from '@app/advisor-frontend';
import { valueID_No, valueID_Suspected } from '@app/hcs-shared';
import { _keys, capitalizeFirstLetter, exists, sortArray } from '@nu-art/ts-common';
import { ModuleFE_AdvisorAnalytics } from '../../../../../_analytics/consts.js';
import { ModuleFE_PanelFindings } from '../../../../../modules/ModuleFE_PanelFindings/ModuleFE_PanelFindings.js';
import { ModuleFE_AdvisorMini } from '../../../../../modules/ModuleFE_AdvisorMini.js';
import { PanelKey_Findings } from '@app/advisor-v5-shared';
const fallback_Title = 'Key History';
const fallback_Subtitle = 'Medical History Highlights';
export class Component_HomeHistory extends ComponentSync {
    //######################### Life Cycle #########################
    __onPractitionerConfigUpdated = () => {
        this.setState({ collapsed: ModuleFE_AdvisorState.getStateProperty.collapsing.homePanel.history() ?? true });
    };
    __onRuntimeFindingsUpdated = () => this.reDeriveState();
    deriveStateFromProps(nextProps, state) {
        state.findings = this.getFindings();
        state.collapsed ??= ModuleFE_AdvisorState.getStateProperty.collapsing.homePanel.history() ?? true;
        const configHomePanel = AdvisorConfigKeyFE_HomePanel.get();
        state.config ??= configHomePanel?.sections?.history;
        state.historyFVId = configHomePanel?.historyFVId;
        return state;
    }
    //######################### Logic #########################
    getFindings() {
        const config = AdvisorConfigKeyFE_HomePanel.get();
        if (!config?.specialAttentionTagId)
            return [];
        const findings = ModuleFE_RuntimeFinding.cache.filter(finding => {
            if (finding.type === 'range')
                return false;
            if (finding.type === 'enumerated' && [valueID_No, valueID_Suspected].includes(finding.valueIds[0]))
                return false;
            const variable = ModuleFE_Advisor_Variable.cache.unique(finding.variableId);
            if (!variable)
                return false;
            return variable.tagIds.some(g => g.value.includes(config.specialAttentionTagId));
        });
        //Group by varId
        const grouped = findings.reduce((map, finding) => {
            if (!map[finding.variableId])
                map[finding.variableId] = [];
            map[finding.variableId].push(finding);
            return map;
        }, {});
        //Sort to latest in each variable
        _keys(grouped).forEach(key => grouped[key] = sortArray(grouped[key], f => f.issuedTimestamp, true));
        //Collect latest
        const latest = _keys(grouped).reduce((latest, key) => {
            return [...latest, grouped[key][0]];
        }, []);
        //Sort by timestamp
        sortArray(latest, f => f.issuedTimestamp, true);
        return latest;
    }
    onOpen = () => {
        if (!this.state.collapsed)
            return;
        ModuleFE_AdvisorState.setProperty.collapsing.homePanel.history(false);
        ModuleFE_AdvisorAnalytics.trigger.view.view__homeHistory();
    };
    onClose = () => {
        if (this.state.collapsed)
            return;
        ModuleFE_AdvisorState.setProperty.collapsing.homePanel.history(true);
    };
    goToHistoryFV = (e) => {
        if (!this.state.historyFVId)
            return;
        e.stopPropagation();
        ModuleFE_PanelFindings.setFindingView(this.state.historyFVId);
        ModuleFE_AdvisorMini.openPanel(PanelKey_Findings);
    };
    //######################### Render #########################
    render() {
        if (!this.state.findings.length || !this.state.config)
            return;
        return _jsx(TS_CollapsableContainerV2, { className: 'home-history', onCollapseToggle: this.onClose, collapsed: this.state.collapsed, headerRenderer: this.render_Header, containerRenderer: this.render_Body, forceUpdate: true, animated: true });
    }
    //######################### Render - Header #########################
    render_Header = () => {
        const title = this.state.config?.title ?? fallback_Title;
        const subtitle = this.state.config?.subtitle ?? fallback_Subtitle;
        const findingCount = this.state.findings.length;
        return _jsxs(_Fragment, { children: [_jsxs(LL_V_L, { children: [_jsxs(LL_H_C, { className: 'home-history__title-wrapper', children: [_jsx("div", { className: 'home-history__title', children: title }), !!findingCount && _jsx("div", { className: 'home-history__count', children: findingCount })] }), exists(subtitle) && _jsx("div", { className: 'home-history__subtitle', children: subtitle })] }), this.render_Header_View()] });
    };
    render_Header_View = () => {
        if (!this.state.collapsed)
            return;
        return _jsx(Button, { variant: 'primary', onClick: this.onOpen, children: "View" });
    };
    //######################### Render - Body #########################
    render_Body = () => {
        return _jsxs(LL_V_L, { className: 'home-history__findings', children: [this.state.findings.map(finding => {
                    const variable = ModuleFE_Advisor_Variable.cache.unique(finding.variableId);
                    if (!variable)
                        return;
                    return _jsx("div", { children: capitalizeFirstLetter(variable.name) }, finding._id);
                }), exists(this.state.historyFVId) && _jsx(Button, { variant: 'primary', onClick: this.goToHistoryFV, children: "Full History" })] });
    };
}
//# sourceMappingURL=Component_HomeHistory.js.map